import { Component, computed, inject, input } from '@angular/core';
import { ProjectPublicResponse } from '@app/models/project.models';
import { FileResponse } from '@app/models/shared.models';
import { FileType } from '@app/models/shared.enums';
import { DownloadService } from '@app/services/file/download.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-project-details-videos',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './project-details-videos.component.html',
  styleUrl: './project-details-videos.component.scss',
})
export class ProjectDetailsVideosComponent {
  private readonly downloadService = inject(DownloadService);
  readonly projectDetails = input.required<ProjectPublicResponse>();

  readonly videos = computed<FileResponse[]>(() => {
    const project = this.projectDetails();
    const files = project.files ?? [];
    return files.filter(
      (file) =>
        file.fileType === FileType.video ||
        file.contentType?.toLowerCase().includes('video')
    );
  });

  onDownloadVideo(event: Event, video: FileResponse): void {
    event.preventDefault();
    this.downloadService
      .downloadFileById(video.id, video.name || 'video')
      .subscribe();
  }
}
